export default __webpack_public_path__ + "static/media/refresh.bce15a3b.svg";